<template>
    <el-dialog title="修改币种" width="1300px" :visible="detailDialogVisible" @close="closeDialog" @open="openDialog">
        <el-form label-width="200px" :model="currency" :rules="rules" ref="currencyForm"
                 :validate-on-rule-change="false">
            <el-row :gutter="50">
                <el-col :span="12">
                    <el-form-item label="币种：" prop="info.coinType">
                        <el-input v-model="currency.info.coinType" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="Logo：" prop="info.logo">
                        <upload url="/admin/coin/upload" :value="currency.info.logo" v-on:input="getSucessInfo"
                                ref="childUpload" :limitNumber="1"
                                :data="{ isSprite: false, coinType: currency.info.coinType }"/>
                    </el-form-item>
                    <el-form-item label="区域：" prop="info.areaType">
                        <el-select v-model="currency.info.areaType">
                            <el-option key="0" label="主区" :value="0"/>
                            <el-option key="1" label="创新区" :value="1"/>
                            <el-option key="2" label="DRWA" :value="2"/>
                            <el-option key="3" label="股票RWA" :value="3"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="聚合交易：" prop="info.supportPolymerTrade">
                        <el-switch v-model="currency.info.supportPolymerTrade" active-color="#13ce66"/>
                    </el-form-item>
                    <el-form-item label="充值：" prop="info.supportDeposit">
                        <el-switch v-model="currency.info.supportDeposit" active-color="#13ce66"/>
                    </el-form-item>
                    <el-form-item label="提现：" prop="info.supportWithdraw">
                        <el-switch v-model="currency.info.supportWithdraw" active-color="#13ce66"/>
                    </el-form-item>
                    <el-form-item label="Memo Needed：" prop="info.memoNeeded">
                        <el-switch v-model="currency.info.memoNeeded" active-color="#13ce66"/>
                    </el-form-item>
                    <el-form-item label="是否支持Memo正则表达式：" prop="info.supportMemoVerify"
                                  v-if="currency.info.memoNeeded">
                        <el-switch v-model="currency.info.supportMemoVerify" active-color="#13ce66"/>
                    </el-form-item>
                    <el-form-item label="Memo正则表达式：" prop="info.memoRegexpExpress"
                                  v-if="currency.info.memoNeeded">
                        <el-input v-model="currency.info.memoRegexpExpress"
                                  :disabled="!currency.info.supportMemoVerify"/>
                    </el-form-item>
                    <el-form-item label="币种全名：" prop="info.coinFullName">
                        <el-input v-model="currency.info.coinFullName"/>
                    </el-form-item>
                    <el-form-item label="最小交易额：" prop="info.minimumTradeAmount">
                        <el-input v-model="currency.info.minimumTradeAmount"/>
                    </el-form-item>
                    <el-form-item label="最小充值额：" prop="info.minChainDepositAmt">
                        <el-input v-model="currency.info.minChainDepositAmt"/>
                    </el-form-item>
                    <el-form-item label="手续费模式：">
                        <el-select disabled v-model="coinCon.withdrawFeeType">
                            <el-option v-if="coinCon.withdrawFeeType==0" key="0" label="模式一" :value="0"/>
                            <el-option v-else key="1" label="模式二" :value="1"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="提现手续费：" prop="info.withdrawFee">
                        <el-input disabled v-model="currency.info.withdrawFee"/>
                        <div style="color:red;font-size:12px;">说明：模式切换以及手续费设置请移步至【充提系统_设置提现手续费】中更改</div>
                    </el-form-item>
                    <el-form-item label="单笔提现额度：" required>
                        <el-col :span="10">
                            <el-form-item prop="info.minWithdrawSingle">
                                <el-input v-model="currency.info.minWithdrawSingle"/>
                            </el-form-item>
                        </el-col>
                        <el-col class="text-center" :span="2">~</el-col>
                        <el-col :span="10">
                            <el-form-item prop="info.maxWithdrawSingle">
                                <el-input v-model="currency.info.maxWithdrawSingle"/>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="当日提现额度：" prop="info.maxWithdrawOneDay">
                        <el-input v-model="currency.info.maxWithdrawOneDay"/>
                    </el-form-item>
                    <el-form-item label="确认数：" prop="info.blockConfirm">
                        <el-input v-model="currency.info.blockConfirm"/>
                    </el-form-item>
                    <el-form-item label="区块时间：" prop="info.blockTime">
                        <el-input v-model="currency.info.blockTime"/>
                    </el-form-item>
                    <el-form-item label="区块链浏览器hash：" prop="info.blockChainHashBuilder">
                        <el-input v-model="currency.info.blockChainHashBuilder"/>
                    </el-form-item>
                    <el-form-item label="区块链浏览器addr：" prop="info.blockChainAddrBuilder">
                        <el-input v-model="currency.info.blockChainAddrBuilder"/>
                    </el-form-item>
                    <el-form-item label="链类型：" prop="info.chainType">
                        <el-input v-model="currency.info.chainType"/>
                    </el-form-item>
                    <el-form-item>
                        <el-radio-group v-model="currency.info.walletType">
                            <el-radio :label="0">本地钱包</el-radio>
                            <el-radio :label="1">cobo钱包</el-radio>
                            <el-radio :label="2">safe钱包</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="充值钱包服务器编号：" prop="info.depositWalletId"
                                  :rules="[{ message: '请选择钱包服务器', required: currency.info.walletType==0 }]">
                        <el-select v-model="currency.info.depositWalletId" placeholder="请选择钱包服务器" multiple
                                   :multiple-limit="1">
                            <el-option v-for="item in withdrawOptions" :key="item.value" :label="item.label"
                                       :value="item.value"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="提现钱包服务器编号：" prop="info.withdrawWalletId"
                                  :rules="[{ message: '请选择钱包服务器', required: currency.info.walletType==0 }]">
                        <el-select v-model="currency.info.withdrawWalletId" placeholder="请选择钱包服务器">
                            <el-option v-for="item in withdrawOptions" :key="item.value" :label="item.label"
                                       :value="item.value"/>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="是否支持地址正则表达式：" prop="info.supportAddrVerify">
                        <el-switch v-model="currency.info.supportAddrVerify" active-color="#13ce66"/>
                    </el-form-item>
                    <el-form-item label="地址正则表达式：" prop="info.addrRegexpExpress">
                        <el-input v-model="currency.info.addrRegexpExpress"
                                  :disabled="!currency.info.supportAddrVerify"/>
                    </el-form-item>
                    <el-form-item label="描述：">
                        <el-input v-model="currency.info.described" :autosize="{ minRows: 4, maxRows: 6}"
                                  type="textarea"/>
                    </el-form-item>
                    <el-form-item label="多链信息(格式为:分隔的 链ChainTypeEnum 的，格式  OMIN_USDT:ERC20_USDTERC20 ，如果为空则表示单链)："
                                  prop="info.multiChainInfo">
                        <el-input v-model="currency.info.multiChainInfo" :autosize="{ minRows: 8, maxRows: 16}"
                                  type="textarea"/>
                    </el-form-item>
                    <el-form-item label="同币名链是否支持充值：" prop="info.baseChainSupportDeposit">
                        <el-switch v-model="currency.info.baseChainSupportDeposit" active-color="#13ce66"/>
                    </el-form-item>
                    <el-form-item label="同币名链是否支持提现：" prop="info.baseChainSupportWithdraw">
                        <el-switch v-model="currency.info.baseChainSupportWithdraw" active-color="#13ce66"/>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <h1 style="margin-left: 50px">站内转提币配置</h1>
                    <el-form-item label="提现：" prop="info.supportInternalWithdraw">
                        <el-switch v-model="currency.info.supportInternalWithdraw" active-color="#13ce66"/>
                    </el-form-item>
                    <el-form-item label="提现手续费：" prop="info.internalWithdrawFee">
                        <el-input v-model="currency.info.internalWithdrawFee"
                                  :disabled="!currency.info.supportInternalWithdraw"/>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <h1 style="margin-left: 50px">系列币配置</h1>
                    <el-form-item label="系列币：" prop="contractInfo.contractCode">
                        <el-select v-model="currency.contractInfo.contractCode" placeholder="请选择系列币"
                                   @change="changeContraxtCode">
                            <el-option label="关闭" value=""/>
                            <el-option v-for="item in contractCodeList" :key="item.contractCode"
                                       :label="item.contractName" :value="item.contractCode"/>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item v-if="contractItem.explorerAddr!=null && contractItem.explorerAddr!=''">
                        <a :href="contractItem.explorerAddr" style="color: red"
                           target="_blank">合约信息要在区块链浏览器上核对,点击浏览</a>
                    </el-form-item>
                    <el-form-item v-for="item in contractItem.fieldsContrast" :label="item.chinese"
                                  v-if="item.show">
                        <el-input v-model="coinConfig[item.field]"/>
                    </el-form-item>
                </el-col>

            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="toggleDetailDialogVisible(false)">取消</el-button>
      <el-button type="primary" @click="handleSave('currencyForm')">保存</el-button>
    </span>
    </el-dialog>
</template>

<script>
    import api from '../../api';
    import {mapState, mapMutations, mapActions, mapGetters} from "vuex";
    import Upload from "components/upload";

    export default {
        name: "CurrencyDetail",
        components: {
            Upload
        },
        data() {
            return {
                withdrawOptions: [
                    {value: 1, label: "wallet-1"},
                    {value: 2, label: "wallet-2"},
                    {value: 3, label: "wallet-3"},
                    {value: 6, label: "wallet-6"},
                    {value: 7, label: "wallet-7"},
                    {value: 8, label: "wallet-8"},
                    {value: 9, label: "wallet-9"},
                    {value: 10, label: "wallet-10"},
                    {value: 11, label: "wallet-11"},
                    {value: 12, label: "wallet-12"},
                    {value: 13, label: "wallet-13"},
                    {value: 14, label: "QB-3"},
                    {value: 15, label: "QB-4"}
                ],
                rules: {
                    "info.code": [{required: true, message: "请输入币种名称"}],
                    "info.maxWithdrawOneDay": [{required: true, message: "请输入当日提现额度"}],
                    "info.maxWithdrawSingle": [{required: true, message: "请输入单笔提现最大额度"}],
                    "info.coinFullName": [{required: true, message: "请输入币种全名"}],
                    "info.minWithdrawSingle": [{required: true, message: "请输入单笔提现最小额度"}],
                    "info.minimumTradeAmount": [{required: true, message: "请输入最小交易额"}],
                    "info.minChainDepositAmt": [{required: true, message: "请输入最小充值额"}],
                    "info.withdrawFee": [{required: true, message: "请输入提现手续费"}],
                    "info.blockConfirm": [{required: true, message: "请输入确认数"}],
                    "info.blockTime": [{required: true, message: "请输入区块时间"}],
                    "info.blockChainHashBuilder": [{required: true, message: "请输区块链浏览器hash地址"}],
                    "info.blockChainAddrBuilder": [{required: true, message: "请输区块链浏览器address地址"}]
                },
                currency: {
                    info: {
                        coinType: "",
                        logo: "",
                        areaType: "",
                        supportDeposit: false,
                        supportWithdraw: false,
                        memoNeeded: false,
                        supportMemoVerify: false,
                        memoRegexpExpress: "",
                        coinFullName: "",
                        minimumTradeAmount: "",
                        minChainDepositAmt: "",
                        withdrawFee: "",
                        minWithdrawSingle: "",
                        maxWithdrawSingle: "",
                        maxWithdrawOneDay: "",
                        blockConfirm: "",
                        blockTime: "",
                        blockChainHashBuilder: "",
                        blockChainAddrBuilder: "",
                        chainType: "",
                        walletType: 0,
                        depositWalletId: [],
                        withdrawWalletId: "",
                        supportAddrVerify: false,
                        addrRegexpExpress: "",
                        described: "",
                        multiChainInfo: "",
                        baseChainSupportDeposit: false,
                        baseChainSupportWithdraw: false,
                        supportInternalWithdraw: false,
                        internalWithdrawFee: "",
                        localWallet: true,
                        coboWallet: false,
                        supportPolymerTrade: false
                    },
                    contractInfo: {
                        contractCode: "",
                        configToJson: "",
                    }
                },
                contractItem: {},
                coinConfig: {},
            };
        },
        computed: {
            ...mapState("currencySetting", ["detailDialogVisible", "currCoinType",'coinCon']),
            ...mapGetters('currencySetting', ['contractCodeList'])
        },
        methods: {
            ...mapMutations("currencySetting", ["toggleDetailDialogVisible"]),
            ...mapActions("currencySetting", ["update",'getCoinConfig']),
            handleSave(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        let searchValue = /^\s+|\s+$/g; //前后空格适配
                        // 去除部分字段中的空格
                        this.currency.info.coinType = this.currency.info.coinType.replace(searchValue, '')
                        // 去除系列币配置中的所有空格
                        this.currency.contractInfo.configToJson = this.currency.contractInfo.contractCode != "" ? JSON.stringify(this.coinConfig).replace(/\s*/g, '') : "";
                        this.currency.info.depositWalletId = (this.currency.info.depositWalletId instanceof Array) ? JSON.stringify(this.currency.info.depositWalletId) : this.currency.info.depositWalletId;
                        this.currency.info.localWallet = this.currency.info.walletType == 0 ? true : false;
                        this.currency.info.coboWallet = this.currency.info.walletType == 1 ? true : false;
                        let paramData = {...this.currency};
                        if (this.currency.contractInfo.contractCode == "") {
                            paramData.contractInfo = null;
                        }

                        this.update(paramData).then(() => {
                            this.$message.success("修改成功！");
                            this.toggleDetailDialogVisible(false);
                            this.$emit("refresh");
                        });
                    }
                });
            },
            getSucessInfo(data) {
                //上传成功
                this.currency.info.logo = data;
            },
            openDialog() {
                // this.getCoinConfig({id:'1'})
                api.detail(this.currCoinType).then(({data}) => {
                    this.currency = data;
                this.getCoinConfig({id:data.info.id})
                    if (this.currency.contractInfo != null && this.currency.contractInfo.configToJson != null && this.currency.contractInfo.configToJson != "") {
                        let configJsonObj = JSON.parse(this.currency.contractInfo.configToJson);
                        this.contractCodeList.forEach(item => {
                            if (item.contractCode == this.currency.contractInfo.contractCode) {
                                for (let i = 0; i < item.fieldsContrast.length; i++) {
                                    this.coinConfig[item.fieldsContrast[i].field] = configJsonObj[item.fieldsContrast[i].field];
                                }
                                this.contractItem = item;
                            }
                        });
                    } else {
                        this.currency.contractInfo = {contractCode: "", configToJson: ""};
                    }

                    if (this.currency.info.withdrawWalletId != null && this.currency.info.withdrawWalletId != "") {
                        this.currency.info.withdrawWalletId = Number(this.currency.info.withdrawWalletId);
                    }
                    if (this.currency.info.depositWalletId != null && this.currency.info.depositWalletId != "") {
                        this.currency.info.depositWalletId = JSON.parse(this.currency.info.depositWalletId);
                    }
                });
            },
            closeDialog() {
                this.$refs.childUpload.handleRemove();
                this.$refs["currencyForm"].resetFields();
                this.coinConfig = {};
                this.contractItem = {};
                this.toggleDetailDialogVisible(false);
            },
            changeContraxtCode(code) {
                this.$refs["currencyForm"].clearValidate();
                this.initData(this.contractItem, false);
                this.contractItem = {};
                this.coinConfig = {};
                if (code != "") {
                    this.contractCodeList.forEach(item => {
                        if (item.contractCode == code) {
                            //判断选择是否和原来的相同，相同就填充原来的数据，否则置空
                            if (this.currency.contractInfo != null && this.currency.contractInfo.configToJson != null && this.currency.contractInfo.configToJson != "" && item.contractCode == this.currency.contractInfo.contractCode) {
                                let configJsonObj = JSON.parse(this.currency.contractInfo.configToJson);
                                for (let i = 0; i < item.fieldsContrast.length; i++) {
                                    this.coinConfig[item.fieldsContrast[i].field] = configJsonObj[item.fieldsContrast[i].field];
                                }
                                this.contractItem = item;
                            } else {
                                for (let i = 0; i < item.fieldsContrast.length; i++) {
                                    this.coinConfig[item.fieldsContrast[i].field] = "";
                                }
                                this.contractItem = item;

                            }
                            this.initData(this.contractItem, true);
                        }
                    });
                }
            },
            initData(item, tag) {
                let mainCodeConf = item.mainCodeConfToJson ? JSON.parse(item.mainCodeConfToJson) : {};
                if (mainCodeConf.withdrawWalletId != null && mainCodeConf.withdrawWalletId != "") {
                    mainCodeConf.withdrawWalletId = Number(mainCodeConf.withdrawWalletId);
                }

                if (mainCodeConf.depositWalletId != null && mainCodeConf.depositWalletId != "") {
                    mainCodeConf.depositWalletId = JSON.parse(mainCodeConf.depositWalletId);
                }
                if (tag) {
                    this.currency = {
                        ...this.currency,
                        info: {
                            ...this.currency.info,
                            ...mainCodeConf
                        }
                    };
                } else {
                    let mainCodeConfEmpty = {};
                    for (let key  in mainCodeConf) {
                        //某些字段特殊处理
                        if ("supportAddrVerify,memoNeeded".indexOf(key) != -1) {
                            mainCodeConfEmpty[key] = false;
                        } else if ("depositWalletId".indexOf(key) != -1) {
                            mainCodeConfEmpty[key] = [];
                        } else {
                            mainCodeConfEmpty[key] = "";
                        }
                    }
                    this.currency = {
                        ...this.currency,
                        info: {
                            ...this.currency.info,
                            ...mainCodeConfEmpty
                        }
                    };
                }
            }
        }
    };
</script>

<style lang="less" scoped>
</style>
